const trafficTag = [
  {
    path: '/traffic-tag',
    component: () => import(/* webpackChunkName: "traffic-tag" */ '@/pages/TrafficTag/index.vue'),
    meta: {
      title: 'Traffic Tag',
    },
  },
];

export default trafficTag;
